import React from 'react'

function Loading() {
    return (
        <div className="loadingPage">
            <div className="loading" style={{
                position: "relative",
                left: "70px"
            }}>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
                <div className="loadingObj"></div>
            </div>
        </div>
    )
}

export default Loading
